module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/api-call-4e911aa2c9785e169f5cc4126af9590f.svg";